export default "__VITE_PUBLIC_ASSET__dcc43e43__"